import { Controller } from "@hotwired/stimulus"

// Clears the form after a successful Turbo submission — the chat composer
// stays put while the message appears via the broadcast.
export default class extends Controller {
  reset(event) {
    if (event.detail?.success !== false) this.element.reset()
  }
}
